export const isActivityDay = (beginDate: Date, endDate: Date): boolean => {
	// recalcul de isDay si les deux dates sont définies

	const dayStartHour = 6;
	const dayEndHour = 22;

	let totalHours = 0;
	let dayHours = 0;

	const current = new Date(beginDate);
	current.setMinutes(0, 0, 0);

	const end = new Date(endDate);

	while (current < end) {
		const next = new Date(current);
		next.setHours(current.getHours() + 1);

		const overlapStart = Math.max(current.getTime(), beginDate.getTime());
		const overlapEnd = Math.min(next.getTime(), endDate.getTime());

		if (overlapStart < overlapEnd) {
			totalHours++;
			const hour = current.getHours();
			if (hour >= dayStartHour && hour < dayEndHour) {
				dayHours++;
			}
		}

		current.setHours(current.getHours() + 1);
	}

	return dayHours >= totalHours / 2;
};
